// let checkMutation = true;
// document.querySelectorAll(".hotspot__tooltip-link").forEach(element => {
//     element.addEventListener("click", (e) => {
//         if (checkMutation) {
//             checkMutation = false;
//             setTimeout(() => {
//               callMutation();
//             }, 200)
//             checkShowModal();
//         }
//     });
// });

// function checkShowModal() {
//     let counter = 0;
//     let selector = ".modal.hotspot__modal.modal--quickshop-full";
//     const interval = setInterval(() => {
//         if (document.querySelector(selector)) {
//            setTimeout(() => {
//               let appliedDisplayRule = BSS_B2B?.td?.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
//               BSS_B2B?.td?.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule);
//               BSS_B2B?.td?.showProductPriceIncludedVat(BSS_B2B, BSS_B2B.shopData);
//             }, 2000)
//             clearInterval(interval);
//         } else {
//             counter += 100;
//             if (counter >= 10000) {
//                 clearInterval(interval);
//             }
//         }
//     }, 100);
// }

// function callMutation(){
//   const targetElement = document.querySelector('.modal.hotspot__modal');
//   if (targetElement) {
//       const observer = new MutationObserver((mutationsList) => {
//         // console.log(mutationsList);
//           for (let mutation of mutationsList) {
//               if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
//                   // console.log(mutation)
//                   if (targetElement.classList.contains('modal--quickshop-full')) {
//                       setTimeout(() => {
//                           let appliedDisplayRule = BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
//                           BSS_B2B?.td?.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule);
//                           BSS_B2B?.td?.showProductPriceIncludedVat(BSS_B2B, BSS_B2B.shopData);
//                       }, 2000);
//                   }
//               }
//           }
//       });
  
//       const config = { attributes: true, attributeFilter: ['class'] };
//       observer.observe(targetElement, config);
//   }
// }

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('hotspot__modal-quickshop')) {
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                   window.dispatchEvent(new Event('scroll'))

                   const productForms = document.querySelectorAll("[bss-b2b-quickview-product-form]");
                    productForms.forEach((productForm) => {
                      BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
                    });
                  setTimeout(() => {
                    const productForms = document.querySelectorAll("[bss-b2b-quickview-product-form]");
                    productForms.forEach((productForm) => {
                      BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
                    });
                  }, 2000);
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}

window.addEventListener("load", e => {
  const isCartPage = window.location.pathname.includes("/cart");
  if(isCartPage) {
    handleCartPage();
  }

  function handleCartPage(){
    const loop = setInterval(() => {
      document.querySelectorAll('.bss-qb-price-item, .bss-qb-total-price-item,.bss-qb-cart-subtotal, [bss-b2b-item-original-price], [bss-b2b-final-line-price], [data-cart-total]').forEach(function (el) {
        if (el.textContent.includes('*')) {
          el.classList.remove('has-star');
        }else{
          el.classList.add('has-star');
        }
      });
    }, 200);
    setTimeout(() => {
      clearInterval(loop);
    }, 5000)
    
  }
})
if(window.location.pathname === '/pages/registrierungprivatperson' || window.location.pathname === '/pages/registrierunggewerbe'){
      const SUBMIT_TEXT = "Registrieren";
      const loop = setInterval(() => {
        if(document.querySelector("input[type='submit']")) {
          clearInterval(loop);
          restyleForm();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(loop);
      }, 10000)
      
      function restyleForm(){
        const btnSubmit = document.querySelector("#bss-b2b-registration-form input[type='submit']")
        if(btnSubmit) {
          btnSubmit.value = SUBMIT_TEXT;
        }
      }
  }
  if(['/pages/wholesale-registration-form', '/pages/wholesale-form'].includes(window.location.pathname)) {
    setTimeout(() => {
      const btnSubmit = document.querySelector(".btn");
  btnSubmit.addEventListener("click", e => {
      let lastName = document.querySelector("#RegisterForm-LastName");
      const val = lastName.value;
      const div = $(lastName).parent();
      if(val.length) {
          if(div.next().hasClass("bss-error-msg")){
              div.next().remove();
          }
      } else {
          // e.preventDefault()
          // if(!div.next().hasClass("bss-error-msg")){
          //     div.after(`<p class="bss-error-msg" style="text-align: center; font-size: 1.4rem; color: #ff0000!important;">
          //                         <span class="bss-b2b-translation-rf-required_field">This field is required</span>
          //                     </p>`);
          // }
        if (window.innerWidth > 719) {
          const fields = document.querySelectorAll('#RegisterForm .field');
          const container = document.createElement('div');
          fields.forEach(field => {
            const wrapper = document.createElement('div');
            field.style.width = "100%"
            field.style.maxWidth = "100%"
            field.style.margin = '0'
            wrapper.style.display = 'block'
            field.parentNode.insertBefore(wrapper, field);
            wrapper.appendChild(field);
            container.appendChild(wrapper);
          });
          container.style.display = 'grid';
          container.style.gridTemplateColumns = 'repeat(2, 1fr)';
          container.style.gap = '20px';
          container.style.margin = '0 10px';
          const referenceElement = document.querySelector('#bss-b2b-registration-form-render');
          if (referenceElement) {
            referenceElement.insertAdjacentElement('afterend', container);
          }
        }
      }
  }, true);
    }, 1000)
  }

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('hotspot__modal-quickshop')) {
            console.log("Phần tử đã xuất hiện");
            const productForms = document.querySelectorAll("[bss-b2b-quickview-product-form]");
              productForms.forEach((productForm) => {
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
              });
            setTimeout(() => {
              const productForms = document.querySelectorAll("[bss-b2b-quickview-product-form]");
              productForms.forEach((productForm) => {
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
              });
            }, 1000);
            
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }